import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinimize = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14 2C14.3682 2 14.6666 2.29848 14.6666 2.66667L14.6666 7H13.3333L13.3333 3.33333H2.66665V12.6667H6.99994L6.99994 14H1.99998C1.63179 14 1.33331 13.7015 1.33331 13.3333V2.66667C1.33331 2.29848 1.63179 2 1.99998 2H14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1572 9.32996L12.9982 11.1711L14.67 9.49943V14H10.1695L11.8411 12.3282L10 10.4872L11.1572 9.32996Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMinimize);
export { ForwardRef as ReactComponent };
